import { MentionInput, ScheduledAttachment, ScheduledMessage } from '../types';
import { apiFetch } from './apiClient';

/**
 * 예약 메시지 REST 클라이언트 (일반 사용자용 — 관리자 공지 예약은 adminService).
 *
 * 상태의 단일 소스는 App.tsx의 myScheduled — 부팅 시 listMine() 1회 + 이후에는
 * 소켓 scheduled-message:* 이벤트(서버 권위 전파)가 갱신한다. 여기 함수들의 반환값은
 * 즉시 반영용이 아니라 호출부 토스트·에러 처리용이다 (보강 emit 금지 원칙과 같은 이유로,
 * REST 성공 응답만으로 상태를 패치하지 않아도 toUser 이벤트가 전 세션을 맞춘다 —
 * 단 App은 반응 속도를 위해 응답으로도 패치하며 이벤트와 id 기준으로 멱등이다).
 */
export interface ScheduledMessageBody {
  content: string;
  scheduledAt: string; // ISO
  mentions?: MentionInput[];
  /**
   * POST /api/upload로 방금 올린 파일(+ 수정 시 그대로 둔 기존 첨부). 이름·크기는 서버가 다시 정한다.
   * 수정(PUT)에서 이 키를 빼면 서버는 기존 첨부를 그대로 둔다.
   */
  attachments?: ScheduledAttachment[];
}

export const scheduledMessageService = {
  /** 내 예약 전체 (대기 + 실패). 부팅·재연결 시 호출 */
  async listMine(): Promise<ScheduledMessage[]> {
    return apiFetch<ScheduledMessage[]>('/scheduled-messages');
  },

  async create(channelId: number, body: ScheduledMessageBody): Promise<ScheduledMessage> {
    return apiFetch<ScheduledMessage>(`/channels/${channelId}/scheduled-messages`, {
      method: 'POST',
      body: JSON.stringify(body),
    });
  },

  async update(id: string, body: ScheduledMessageBody): Promise<ScheduledMessage> {
    return apiFetch<ScheduledMessage>(`/scheduled-messages/${id}`, {
      method: 'PUT',
      body: JSON.stringify(body),
    });
  },

  /** 대기 중이면 취소, 실패 행이면 목록에서 제거 — 서버가 구분한다 */
  async cancel(id: string): Promise<ScheduledMessage> {
    return apiFetch<ScheduledMessage>(`/scheduled-messages/${id}`, {
      method: 'DELETE',
    });
  },
};
